export const APP_SET = 'APP_SET';

export let setApp = (data) => {
	return {
		type: APP_SET,
		data
	};
};